<template>
    <el-tooltip ref="tooltip" :popper-class="'action-tooltip no-print' + (!visibleArrow ? ' no-arrow' : '')" :effect="effect" :content="content" :placement="placement" :disabled="disabled" :visible-arrow="visibleArrow" :offset="offset">
        <slot></slot>
        <slot name="content" slot="content"></slot>
    </el-tooltip>
</template>

<script>
export default {
    // eslint-disable-next-line
    name: 'tooltip',
    props: {
        content: String,
        placement: {
            type: String,
            default: 'bottom'
        },
        disabled: Boolean,
        effect: {
            type: String,
            default: 'dark'
        },
        visibleArrow: {
            type: Boolean,
            default: true
        },
        offset: {
            type: Number,
            default: 0
        }
    },
}
</script>

<style lang="scss">
.action-tooltip {
    border-radius: $--border-radius-base;
    padding-left: 16px;
    padding-right: 16px;
    max-width: 200px;
    line-height: 1.5;
    padding-top: 6px;
    padding-bottom: 6px;

    &.no-arrow {
        margin-top: 6px;
    }

    &.is-light {
        box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.1);
        border-color: $--border-color-lighter;
    }

    &.is-light[x-placement^=right] .popper__arrow {
        border-right-color: $--border-color-lighter;
    }
    &.is-light[x-placement^=left] .popper__arrow {
        border-left-color: $--border-color-lighter;
    }
    &.is-light[x-placement^=top] .popper__arrow {
        border-top-color: $--border-color-lighter;
    }
    &.is-light[x-placement^=bottom] .popper__arrow {
        border-bottom-color: $--border-color-lighter;
    }
}
</style>